import { useMemo } from 'react';

import StarIcon from '@/fo/icons/base/icons/star.svg';

import { styles } from './UiKitRatingBase.styles';

export interface UiKitRatingBaseProps {
  value: number;
  maxValue?: number;
  className?: string;
  starClassName?: string;
}

const fillMap = {
  0: '0%',
  0.5: '50%',
  1: '100%'
};

/**
 * Базовый компонент звездного рейтинга с шагом 0.5
 */
export function UiKitRatingBase({
  value,
  maxValue = 5,
  className,
  starClassName
}: UiKitRatingBaseProps) {
  const slots = styles();

  const starsArray = useMemo(() => {
    return Array.from({ length: maxValue }).map((_, index) => {
      const diff = value - index;
      let starFill: 0 | 0.5 | 1 = 0;

      if (diff >= 0.75) {
        starFill = 1;
      } else if (diff >= 0.25) {
        starFill = 0.5;
      }

      return {
        key: index,
        fillPercentage: fillMap[starFill]
      };
    });
  }, [value, maxValue]);

  return (
    <div className={slots.container({ className })}>
      {starsArray.map(({ key, fillPercentage }) => (
        <div
          key={key}
          className={slots.starWrapper()}
        >
          <StarIcon className={slots.star({ className: starClassName })} />

          <div
            className={slots.starFilled()}
            style={{
              width: fillPercentage
            }}
          >
            <StarIcon className={slots.star({ className: starClassName })} />
          </div>
        </div>
      ))}
    </div>
  );
}
